import React from 'react';

export const EmptyStateIllustration: React.FC = () => (
  <svg
    width="144"
    height="144"
    viewBox="0 0 144 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-testid="empty-state-illustration"
  >
    {/* Document body */}
    <rect
      x="36"
      y="24"
      width="60"
      height="84"
      rx="3"
      fill="#FFFFFF"
      stroke="#1A1A1A"
      strokeWidth="2"
    />
    {/* Document fold (top-right corner) */}
    <path
      d="M84 24 L96 36 L84 36 Z"
      fill="#E5E5E5"
      stroke="#1A1A1A"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    {/* X mark in centre */}
    <line
      x1="56"
      y1="60"
      x2="76"
      y2="80"
      stroke="#1A1A1A"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <line
      x1="76"
      y1="60"
      x2="56"
      y2="80"
      stroke="#1A1A1A"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    {/* Red diagonal slash */}
    <line
      x1="20"
      y1="120"
      x2="100"
      y2="20"
      stroke="#D32F2F"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
